import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { FileText, ClipboardList, Package, Truck, Wrench, Plus } from 'lucide-react';

const ACTIONS = [
  { key: 'so',  label: 'Sales Order',      icon: FileText,       tone: 'bg-blue-50 border-blue-200 text-blue-800 hover:bg-blue-100',             route: '/orders/sales' },
  { key: 'po',  label: 'Production Order', icon: ClipboardList,  tone: 'bg-amber-50 border-amber-200 text-amber-800 hover:bg-amber-100',         route: '/orders/production' },
  { key: 'ps',  label: 'Packing Slip',     icon: Package,        tone: 'bg-sky-50 border-sky-200 text-sky-800 hover:bg-sky-100',                 route: '/orders/packing/new' },
  { key: 'bol', label: 'Bill of Lading',   icon: Truck,          tone: 'bg-indigo-50 border-indigo-200 text-indigo-800 hover:bg-indigo-100',     route: '/orders/bol/new' },
  { key: 'ro',  label: 'Lyphline Repair',  icon: Wrench,         tone: 'bg-emerald-50 border-emerald-200 text-emerald-800 hover:bg-emerald-100', route: '/orders/repairs/new' },
];

const DashboardQuickCreate = () => {
  const navigate = useNavigate();

  return (
    <Card className="industrial-card" data-testid="dashboard-quick-create">
      <CardContent className="p-4">
        <div className="flex items-center gap-2 mb-3">
          <div className="w-6 h-6 rounded-sm bg-slate-900 flex items-center justify-center">
            <Plus className="w-3.5 h-3.5 text-white" />
          </div>
          <div>
            <div className="text-sm font-bold text-slate-900 uppercase tracking-wider">Create New</div>
            <div className="text-[11px] text-slate-500">One-click intake for every customer-facing document</div>
          </div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-2">
          {ACTIONS.map(a => {
            const Icon = a.icon;
            return (
              <Button
                key={a.key}
                variant="outline"
                onClick={() => navigate(a.route)}
                data-testid={`quick-create-${a.key}`}
                className={`${a.tone} rounded-sm justify-start h-auto py-2.5 px-3 border transition-colors`}
              >
                <Icon className="w-4 h-4 mr-2 shrink-0" />
                <span className="flex-1 text-left">
                  <span className="block text-xs font-semibold leading-tight">{a.label}</span>
                  <span className="block text-[10px] opacity-70">New {a.label.toLowerCase()}</span>
                </span>
                <Plus className="w-3 h-3 ml-1 shrink-0 opacity-60" />
              </Button>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};

export default DashboardQuickCreate;
